export default __webpack_public_path__ + "static/media/triangle.4582263e.png";